import Tab from 'react-bootstrap/Tab';
import Nav from 'react-bootstrap/Nav';
import ModalHeader from '../../Setup/Shared/ModalHeader';
import DatePicker from '../../General/DatePicker';
import { Modal } from "react-bootstrap";
import { enumUtil } from '../../../utils/Enum';
import { useEffect, useRef, useState } from 'react';
import { ServerRequestProtected, ServerRequestProtectedOCR } from '../../../utils/ServerDataRequest';
import NotificationHandler from '../../../utils/NotificationHandler';
import isNull from '../../../utils/NullChecking';
import { format } from 'date-fns';
import { useSelector } from 'react-redux';
import handleNumericCheck from '../../../utils/HandleNumericKeys';
import Loader from '../Loader/Loader';
import FormValidator from '../../../utils/FormValidator';
import handleDecimalCheck from '../../../utils/handleDecimalCheck';
import PatAdvancePaymentConfirmation from '../../Patient/PatientDetails/PatientPayment/PatAdvancePaymentConfirmation';
import ModalFooter from '../../Setup/Shared/ModalFooter';
const CollectCopay = (props) => {
    let { isOpenCopay, OnCloseCopay, PatientID, type, ID, AdvancePayment } = { ...props }
    const Copay = () => {
        return <p style={{ color: '#434343', fontFamily: 'Poppins', fontWeight: '600', margin: '0', fontSize: '14px', fontWeight: '600', }}> Copay Collection</p>;
    };


    let Cash_Modal = {
        CopayDue: 'true',
        // Comments: '',
        // DateCollected: null,
        PaymentMethod: '',
    }
    let Check_Modal = {
        CopayDue: 'true',
        Check: '',
        CheckAmount: '',
        // Comments: '',
        // DateCollected: null,
        PaymentMethod: '',
    }
    let Other_Modal = {
        CopayDue: 'true',
        OtherPaymentMethod: '',
        // Comments: '',
        // DateCollected: null,
        PaymentMethod: '',
    }
    let Credit_Modal = {
        CopayDue: 'true',
        CreditCard: '',
        Last4Digits: '',
        // Comments: '',
        // DateCollected: null,
        PaymentMethod: '',
    }
    let Pateint_Modal = {
        PatientName: '',
        LastName: '',
        Age: '',
        Gender: '',
        Providers: '',
        FollowUpVisit: '',
        Copay: ''
    }
    const API_URL = enumUtil.controller.Claim
    const API_URL_Payment = enumUtil.controller.PatientPayment
    const [patientID, setPatientID] = useState('')
    const [mainCash, setmainCash] = useState(Cash_Modal)
    const [saveUpdatedCash, setsaveUpdatedCash] = useState({})
    const [mainCheck, setmainCheck] = useState(Check_Modal)
    const [saveUpdatedCheck, setsaveUpdatedCheck] = useState({})
    const [mainOther, setmainOther] = useState(Other_Modal)
    const [saveUpdatedOther, setsaveUpdatedOther] = useState({})
    const [mainCredit, setmainCredit] = useState(Credit_Modal)
    const [saveUpdatedCredit, setsaveUpdatedCredit] = useState({})
    const [mainPtCredit, setmainPtCredit] = useState(Check_Modal)
    const [saveUpdatedPtCredit, setsaveUpdatedPtCredit] = useState({})
    const [mainPateintModal, setmainPatientModal] = useState(Pateint_Modal)
    const [paymentMethod, setpaymentMethod] = useState('Cash')
    const [mainCopayPaymentSave, setmainCopayPaymentSave] = useState({})
    const [DateCollected, setDateCollected] = useState(null)
    const [Comments, setComments] = useState('')
    const [isDateGreater, setisDateGreater] = useState('')
    const [PatientName, setPatientName] = useState('')
    const [patientBody, setPatientBody] = useState({ "TableName": "", "SearchParam": '' })
    const [isPateintAvailable, setisPateintAvailable] = useState(false)
    const [is, setIs] = useState(false);
    const [isLoading, setIsLoading] = useState(false)
    const [isCopayAlreadyPaid, setisCopayAlreadyPaid] = useState(false);
    const [CollectedAmount, setCollectedAmount] = useState("")
    const [gender, setGender] = useState('')
    const [name, setName] = useState('')
    let ClaimIDR = useSelector(state => state.Open_Claim_Tab.find((pt) => pt.active === true));
    let paymentGateWayTokenizerURL = useSelector(state => state.SettingsReducer?.paymentGateWayTokenizerURL);

    if (ClaimIDR && ClaimIDR.data) {
        ClaimIDR = ClaimIDR.data.id;
    }
    useEffect(() => {
        if (!isNull(PatientID)) {
            setPatientID(PatientID)
        }
        if (!isNull(patientID)) {
            setIsLoading(true);
            ServerRequestProtected(API_URL_Payment + "/GetPatientDetailsForCopay", 'post', {
                "TableName": enumUtil.enumAPITableName.CollectCopay,
                "SEARCHCRITERIA": {
                    "PatientID": PatientID + "",
                    "ClaimID": type === 'Claim' ? ID + "" : '',
                    "PatientAppointmentID": type === 'PatientAppointment' ? ID + "" : '',
                }
            })
                .then((response) => {
                    setIsLoading(false);
                    // if (response.Copay === 0) {
                    //     NotificationHandler('Please enter copay amount first!', enumUtil.enumtoaster.warning)
                    //     OnCloseCopay()
                    // } else {
                    if (AdvancePayment > 0 && response.CopayCollection !== 'True') {
                        setisOpenPatAdvPayment(true)
                    }
                    setmainPatientModal(response)
                    setGender(response?.Gender)
                    setName(response?.PatientName)
                    // setCollectedAmount(response.Copay + "")
                    setisPateintAvailable(true)
                    if (response.CopayCollection === 'True') {
                        setisCopayAlreadyPaid(true)
                    } else {
                        setisCopayAlreadyPaid(false)
                    }
                    // }
                }).catch((error) => {
                    setIsLoading(false)
                    setisPateintAvailable(false)
                    NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
                })
        }
    }, [patientID])

    let valModal = {}
    let ValidationModal = {
        DateCollectedVal: '',
        CollectedAmountVal: '',
    }
    const [validation, setValidation] = useState({ ValidationModal })
    const CopayValidation = async () => {
        let ValidationModal = {
            DateCollectedVal: FormValidator(
                DateCollected,
                enumUtil.enumValidationType.Required,
                'Date ',
            ),
            CollectedAmountVal: FormValidator(
                CollectedAmount,
                enumUtil.enumValidationType.Required,
                'Amount ',
            ),
        }
        await setValidation(ValidationModal)
        valModal = ValidationModal

    }
    const PatientPaymentValidationCheck = async () => {
        let ValidationModal = {
            CheckVal: FormValidator(
                mainCheck.Check,
                enumUtil.enumValidationType.Required,
                'Check # ',
            ), DateCollectedVal: FormValidator(
                DateCollected,
                enumUtil.enumValidationType.Required,
                'Date ',
            ),
            CollectedAmountVal: FormValidator(
                CollectedAmount,
                enumUtil.enumValidationType.Required,
                'Amount ',
            )
        }
        await setValidation(ValidationModal)
        valModal = ValidationModal
    }
    const PatientPaymentValidationCredit = async () => {
        let ValidationModal = {
            // CreditVal: FormValidator(
            //     mainCredit.CreditCard,
            //     enumUtil.enumValidationType.Required,
            //     'CreditCard ',
            // ),
            DateCollectedVal: FormValidator(
                DateCollected,
                enumUtil.enumValidationType.Required,
                'Date ',
            ),
            CollectedAmountVal: FormValidator(
                CollectedAmount,
                enumUtil.enumValidationType.Required,
                'Amount ',
            )
        }
        await setValidation(ValidationModal)
        valModal = ValidationModal

    }
    const handleChangeAmount = (e) => {
        setCollectedAmount(e.target.value)
    }
    const handleChangePatientPayment = (e, type) => {
        let { name, value } = e.target
        if (type === 'cash') {
            let modal = { ...mainCash }
            let saveModal = { ...saveUpdatedCash }
            if (name === 'CopayDue') {
                modal[name] = !modal[name]
            } else {
                modal[name] = value
            }
            setmainCash(modal)
            for (var property in Cash_Modal) {
                if (name === property) {
                    if (name === 'CopayDue') {
                        saveModal[name] = modal[name] + ""
                    } else {
                        saveModal[name] = value
                    }
                }
            }
            setsaveUpdatedCash(saveModal)
        } else if (type === 'check') {
            let modal = { ...mainCheck }
            let saveModal = { ...saveUpdatedCheck }
            if (name === 'CopayDue') {
                modal[name] = !modal[name]
            } else {
                modal[name] = value
            }
            setmainCheck(modal)
            for (var property in Check_Modal) {
                if (name === property) {
                    if (name === 'CopayDue') {
                        saveModal[name] = modal[name] + ""
                    } else {
                        saveModal[name] = value
                    }
                }
            }
            setsaveUpdatedCheck(saveModal)
        } else if (type === 'credit') {
            let modal = { ...mainCredit }
            let saveModal = { ...saveUpdatedCredit }
            if (name === 'CopayDue') {
                modal[name] = !modal[name]
            } else {
                modal[name] = value
            }
            setmainCredit(modal)
            for (var property in Credit_Modal) {
                if (name === property) {
                    if (name === 'CopayDue') {
                        saveModal[name] = modal[name] + ""
                    } else {
                        saveModal[name] = value
                    }
                }
            }
            setsaveUpdatedCredit(saveModal)
        } else if (type === 'other') {
            let modal = { ...mainOther }
            let saveModal = { ...saveUpdatedOther }
            if (name === 'CopayDue') {
                modal[name] = !modal[name]
            } else {
                modal[name] = value
            }
            setmainOther(modal)
            for (var property in Other_Modal) {
                if (name === property) {
                    if (name === 'CopayDue') {
                        saveModal[name] = modal[name] + ""
                    } else {
                        saveModal[name] = value
                    }
                }
            }
            setsaveUpdatedOther(saveModal)
        } else if (type === 'ptcredit') {
            let modal = { ...mainPtCredit }
            let saveModal = { ...saveUpdatedPtCredit }
            if (name === 'CopayDue') {
                modal[name] = !modal[name]
            } else {
                modal[name] = value
            }
            setmainPtCredit(modal)
            for (var property in Cash_Modal) {
                if (name === property) {
                    if (name === 'CopayDue') {
                        saveModal[name] = modal[name] + ""
                    } else {
                        saveModal[name] = value
                    }
                }
            }
            setsaveUpdatedPtCredit(saveModal)
        }

    }
    //Payment flow
    let BASE_URL = process.env.REACT_APP_FURL
    const [isCreditPaymentSucess, setisCreditPaymentSucess] = useState(false)
    const [creditPaymentRecipt, setCreditPaymentRecipt] = useState('')
    const API_URL_InovicePayment = enumUtil.controller.InovicePayment
    const API_URL_PatientPay = enumUtil.controller.PatientPay
    const stripeSessionRef = useRef(null);
    const listenForStripeResult = (popup) => {
        const messageHandler = (event) => {
            console.log("MESSAGE RECEIVED FROM POPUP:", event);

            // ✅ ACCEPT ONLY SAME-ORIGIN MESSAGES
            // if (event.origin !== window.location.origin) return;

            // ✅ IGNORE REACT DEVTOOLS / EXTENSIONS
            if (!event.data || event.data.source === "react-devtools-bridge") return;

            let { sessionID, PaymentIntentId, status, receiptUrl } = event.data || {};

            console.log(
                sessionID,
                PaymentIntentId,
                status,
                receiptUrl,
                event.data,
                "Stripe"
            );

            // ✅ ONLY PROCESS REAL STRIPE DATA
            if (!sessionID) return;

            setCreditPaymentRecipt(receiptUrl);

            stripeSessionRef.current = {
                sessionID,
                PaymentIntentId,
                status,
                receiptUrl
            };

            console.log("Stripe Session ID:", stripeSessionRef.current);
            console.log("Payment Intent ID:", PaymentIntentId);

            window.removeEventListener("message", messageHandler);
            popup?.close(); // close automatically after save
        };

        // ✅ Attach listener
        window.addEventListener("message", messageHandler);

        // 🔒 KEEPING YOUR MANUAL CLOSE + SAVE LOGIC EXACTLY
        const timer = setInterval(() => {
            if (popup.closed) {
                clearInterval(timer);
                window.removeEventListener("message", messageHandler);
                console.log("Stripe popup closed manually", stripeSessionRef);

                if (stripeSessionRef.current?.status === "Success") {
                    handleSaveCopayActual(
                        stripeSessionRef.current.sessionID,
                        stripeSessionRef.current.PaymentIntentId
                    );
                } else {
                    NotificationHandler(
                        "Payment Failed, please try again",
                        enumUtil.enumtoaster.error
                    );
                    setisCreditPaymentSucess(false);
                }
            }
        }, 300);
    };
    const paymentListeners = useRef({
        active: false,
        processedPaymentIds: new Set()
    });
    const listenForInternalPaymentResult = (popup) => {
        // If already listening, don't add another listener
        // debugger
        if (paymentListeners.current.active) {
            console.log('Payment listener already active, ignoring duplicate');
            return;
        }
        paymentListeners.current.active = true;
        const messageHandler = (event) => {
            if (event.origin !== window.location.origin) return;
            if (!event.data || event.data.source === "react-devtools-bridge") return;
            const { paymentId, status, printStatementsLogsID, error } = event.data || {};
            console.log(error);

            if (!isNull(error)) {
                NotificationHandler(error, enumUtil.enumtoaster.error);
                return
            }
            if (!paymentId) return;
            // Check if this payment was already processed
            if (paymentListeners.current.processedPaymentIds.has(paymentId)) {
                console.log('Payment ID already processed:', paymentId);
                return;
            }
            // Mark as processed
            paymentListeners.current.processedPaymentIds.add(paymentId);
            // Cleanup
            window.removeEventListener("message", messageHandler);
            paymentListeners.current.active = false;

            // if (window.paymentPopupInterval) {
            //     clearInterval(window.paymentPopupInterval);
            //     window.paymentPopupInterval = null;
            // }
            popup?.close();
            if (status === "Success") {
                handleSaveCopayActual(paymentId, '', printStatementsLogsID);
                localStorage.removeItem('PatientPaymentDetails');
            } else {
                NotificationHandler(
                    "Payment Failed, please try again",
                    enumUtil.enumtoaster.error
                );
                localStorage.removeItem('PatientPaymentDetails');
            }
        };
        window.addEventListener("message", messageHandler);
        // window.paymentPopupInterval = setInterval(() => {
        //     if (popup.closed) {
        //         clearInterval(window.paymentPopupInterval);
        //         window.paymentPopupInterval = null;
        //         window.removeEventListener("message", messageHandler);
        //         paymentListeners.current.active = false;
        //     }
        // }, 300);
    };
    const SummaryViewPayment = () => {
        setIsLoading(true);

        // ✅ Open popup immediately (user action context)
        const popup = window.open(
            "",
            "StripePayment",
            "width=500,height=700"
        );

        if (!popup) {
            setIsLoading(false);
            alert(
                "Popup blocked!\n\n" +
                "Please allow popups for this site and try again.\n\n" +
                "Chrome: Click address bar → Popups → Allow"
            );
            return;
        }

        // Optional loading message
        popup.document.write("<p style='font-family:sans-serif'>Loading payment...</p>");

        ServerRequestProtectedOCR(
            API_URL_InovicePayment + "/checkout-session",
            "post",
            {
                amount: CollectedAmount,
                reason: saveUpdatedCredit.Comments,
                PatientID: PatientID + ""
            }
        )
            .then((response) => {
                const appealLink = response?.checkoutUrl;

                if (!appealLink) {
                    popup.close();
                    NotificationHandler("Payment URL not found!", enumUtil.enumtoaster.error);
                    return;
                }

                // ✅ Redirect popup instead of opening new one
                popup.location.href = appealLink;

                listenForStripeResult(popup);
            })
            .catch((error) => {
                popup.close();
                NotificationHandler(error.response?.data, enumUtil.enumtoaster.error);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };
    const DetailedViewPayment = () => {
        setIsLoading(true)
        // ServerRequestProtectedOCR(API_URL_InovicePayment + "/checkout-session-list", 'post', {
        ServerRequestProtectedOCR(API_URL_PatientPay + "/ProcessPayment", 'post', {
            // amount: CollectedAmount,
            // reason: saveUpdatedCredit.Comments,
            PatientID: patientID + '',
            ProcedureItems: [
                {
                    "unitAmount": CollectedAmount,
                    "Units": 1,
                    "name": mainPateintModal.name
                }
            ],
            // PrintStatementsLogsID: PrintStatementsLogsID ? PrintStatementsLogsID : '',
            // StatementNumber: StatementNumber ? StatementNumber : ''
            PrintStatementsLogsID: '',
            StatementNumber: ''
        }).then((response) => {
            let appealLink = response?.checkoutUrl;
            if (appealLink) {
                if (response?.paymentGateWay === 'Stripe') {
                    const width = Math.floor(window.screen.width * 0.83);
                    const height = Math.floor(window.screen.height * 0.76);
                    const left = (window.screenLeft || window.screenX) + (window.innerWidth - width);
                    const top = (window.screenTop || window.screenY) + (window.innerHeight - height);
                    // `width=${width},height=${height},left=${left},top=${top}`
                    const popup = window.open(
                        appealLink,
                        'StripePayment',
                        "width=500,height=700",
                    );
                    if (!popup) {
                        alert("Popup blocked. Please allow popups.");
                        setIsLoading(false)
                        return;
                    }
                    listenForStripeResult(popup);
                    setIsLoading(false)
                } else {
                    let data = { ...response, paymentGateWayTokenizerURL: paymentGateWayTokenizerURL }
                    localStorage.setItem('PatientPaymentDetails', JSON.stringify(data));
                    // 'https://portal.theeasyedi.com/#/PatientPayment',
                    // 'http://localhost:3000/#/PatientPayment',
                    const popup = window.open(
                        // `${BASE_URL}#/PatientPayment`,
                        // 'https://portal.theeasyedi.com/#/PatientPayment',
                        'http://localhost:3000/#/PatientPayment',
                        'InternalPayment',
                        "width=800,height=700"
                    );
                    if (!popup) {
                        alert("Popup blocked. Please allow popups.");
                        return;
                    }
                    listenForInternalPaymentResult(popup);
                    setIsLoading(false)
                    // localStorage.setItem('PatientPaymentDetails', JSON.stringify(response));
                    // window.open('http://localhost:3000/#/PatientPayment', '_blank');
                }
            }
            else {
                NotificationHandler('Page Not Found!', enumUtil.enumtoaster.error)
            }
        }).catch((error) => {
            setIsLoading(false)
            NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
        })
    }
    const handleSaveCopay = async () => {
        if (paymentMethod === 'Credit') {
            await PatientPaymentValidationCredit()
            let validation = FormValidator([valModal], enumUtil.enumValidationType.NullCheck)
            if (validation) {
                NotificationHandler('Fill Required Fields', enumUtil.enumtoaster.error)
                return
            } else {
                // if (InvoiceMode === 'Detail View') {
                DetailedViewPayment()
                // } else if (InvoiceMode === 'Summary View') {
                //     SummaryViewPayment()
                // }
            }
        } else {
            handleSaveCopayActual()
        }
    }
    const isProcessingPayment = useRef(false);
    const handleSaveCopayActual = async (SessionID, PaymentIntentId) => {
        if (isProcessingPayment.current) {
            console.log('Payment already being processed, ignoring duplicate call');
            return;
        }
        isProcessingPayment.current = true;
        let AmountValidation = false
        let ZeroCopayMessage = ''
        // debugger
        if (mainPateintModal.Copay !== "") {
            // if (CollectedAmount - "" > mainPateintModal.Copay - "") {
            //     AmountValidation = true
            //     ZeroCopayMessage = 'Collected amount cannot be greater than Copay'
            // } else if (mainPateintModal.Copay === 0) {
            //     AmountValidation = true
            //     ZeroCopayMessage = "Cannot save when copay amount is zero/0"
            // } else 
            if (paymentMethod === 'Patient Credit' && CollectedAmount - "" > AdvancePayment) {
                AmountValidation = true
                ZeroCopayMessage = "Collected amount cannot be greater than patient credit amount"
            }
        }
        await CopayValidation()
        if (paymentMethod === 'Credit') {
            isProcessingPayment.current = false;
            await PatientPaymentValidationCredit()
        } else if (paymentMethod === 'Check') {
            isProcessingPayment.current = false;
            await PatientPaymentValidationCheck()
        }
        let validation = FormValidator([valModal], enumUtil.enumValidationType.NullCheck)
        if (validation || !isNull(isDateGreater)) {
            isProcessingPayment.current = false;
            NotificationHandler('Fill Required Fields', enumUtil.enumtoaster.error)
            return
        } else if (AmountValidation === true) {
            isProcessingPayment.current = false;
            NotificationHandler(ZeroCopayMessage, enumUtil.enumtoaster.error)
            return
        } else {
            let SaveModal
            if (paymentMethod === 'Cash') {
                SaveModal = { ...saveUpdatedCash, CollectedDate: DateCollected, CollectedAmount: CollectedAmount, Comments: Comments, PaymentMethod: paymentMethod }
            } else if (paymentMethod === 'Check') {
                SaveModal = { ...saveUpdatedCheck, CollectedDate: DateCollected, CollectedAmount: CollectedAmount, Comments: Comments, PaymentMethod: paymentMethod }
            } else if (paymentMethod === 'Credit') {
                SaveModal = {
                    ...saveUpdatedCredit, CollectedDate: DateCollected, CollectedAmount: CollectedAmount,
                    Comments: Comments, PaymentMethod: paymentMethod, SessionID: SessionID ? SessionID : '', PaymentIntentId: PaymentIntentId,
                }
            } else if (paymentMethod === 'Other') {
                SaveModal = { ...saveUpdatedOther, CollectedDate: DateCollected, CollectedAmount: CollectedAmount, Comments: Comments, PaymentMethod: paymentMethod }
            } else if (paymentMethod === 'Patient Credit') {
                SaveModal = { ...saveUpdatedPtCredit, CollectedDate: DateCollected, CollectedAmount: CollectedAmount, Comments: Comments, PaymentMethod: paymentMethod }
            } else {
                SaveModal = { ...saveUpdatedCash, CollectedDate: DateCollected, CollectedAmount: CollectedAmount, Comments: Comments, PaymentMethod: 'Cash' }
            }

            if (type === 'Claim') {
                SaveModal['ClaimID'] = ID + ""
                SaveModal['PatientID'] = PatientID + ""
                SaveModal['PaymentType'] = 'Copay'
            } else if (type === 'Payment') {
                SaveModal['Payment'] = ID
                SaveModal['PatientID'] = PatientID + ""
                SaveModal['PaymentType'] = 'Copay'
            } else if (type === 'PatientAppointment') {
                SaveModal['PatientAppointmentID'] = ID + ""
                SaveModal['PatientID'] = PatientID + ""
                SaveModal['PaymentType'] = 'Copay'
            }
            let saveModal = {
                TableName: enumUtil.enumAPITableName.CollectCopay,
                ID: 0,
                data: SaveModal,
                value: null
            }
            setIsLoading(true)
            ServerRequestProtected(API_URL_Payment + "/CollectCopay", 'post', saveModal).then((response) => {
                if (!isNull(response.id)) {
                    isProcessingPayment.current = false;
                    setIsLoading(false)
                    NotificationHandler('Record Saved Successfully!', enumUtil.enumtoaster.success)
                    localStorage.removeItem('PatientPaymentDetails');
                    OnCloseCopay('Copay')
                }
            }).catch((error) => {
                setIsLoading(false)
                isProcessingPayment.current = false;
                NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
                localStorage.removeItem('PatientPaymentDetails');
            })
        }
    }
    const handleChangeLink = (type) => {
        setpaymentMethod(type)
    }
    const handleCalendarChange = (date, type) => {
        if (date > new Date()) {
            setisDateGreater(<div className="invalid-feedback" style={{ display: "block" }}>Date cannot be greater than current date</div>)
        } else {
            setisDateGreater('')
            var FormatedDate = date
            setDateCollected(FormatedDate)
        }

    }
    const handleCopayPaid = () => {
        isProcessingPayment.current = false;
        OnCloseCopay()
        setisCopayAlreadyPaid(false)
    }
    const [isOpenPatAdvPayment, setisOpenPatAdvPayment] = useState(false)
    const closePatAdvPayentConf = () => {
        setisOpenPatAdvPayment(false)
    }
    const onProceddPatAdvPayentConf = () => {
        setisOpenPatAdvPayment(false)
        handleChangeLink('Patient Credit')
    }
    let AdvancePopup
    if (isOpenPatAdvPayment) {
        AdvancePopup = <PatAdvancePaymentConfirmation isOpenPatAdvPayment={isOpenPatAdvPayment} closePatAdvPayentConf={closePatAdvPayentConf} onProceddPatAdvPayentConf={onProceddPatAdvPayentConf} AdvancePayment={AdvancePayment} />
    }
    const getInitials = (name) => {
        const nameArray = name.split(' ');
        if (nameArray.length >= 2) {
            return nameArray[1][0] + nameArray[0][0];
        } else if (nameArray.length === 1) {
            return nameArray[0][0];
        }
        return '';
    };
    const userInitials = getInitials(name)
    return (
        <>
            {AdvancePopup}
            <Modal show={isOpenCopay} onHide={isOpenCopay} backdrop="static" keyboard={false} centered dialogClassName="app-modal hk-modal-v1 add_block_appointment">
                {isLoading ? <Loader /> : null}
                <Modal.Body>
                    <ModalHeader HeaderName={Copay} DeletePopup={""} isClosed={OnCloseCopay} key={111} Name={'Copay'} />
                    <div className='inside_body'>
                        {/* <img src={mainPateintModal.ProfilePicture ? mainPateintModal.ProfilePicture : "https://www.w3schools.com/howto/img_avatar.png"} alt="" /> */}

                        {isPateintAvailable === true ?
                            <>
                                <div className="ar-copay-img d-flex">
                                    <div className="img-container s-50 circle ">
                                        {mainPateintModal.ProfilePicture ?
                                            <img src={mainPateintModal.ProfilePicture} alt="" />
                                            :
                                            <p
                                                className={`align-items-center d-flex h-100 heading justify-content-center w-100 fs-14 text-white ${gender === 'M'
                                                    ? 'za-male'
                                                    : gender === 'F'
                                                        ? 'za-female'
                                                        : 'za-others'
                                                    }`}
                                            >
                                                {userInitials}
                                            </p>
                                        }

                                    </div>
                                    <div className='ms-1 w-100'>
                                        <p className="heading">{mainPateintModal.PatientName} <span className='font-r ps-2px'> {mainPateintModal.DOB}  {!isNull(mainPateintModal.Age) ? '(' + mainPateintModal.Age + ') ' + mainPateintModal.Gender : ''}</span></p>
                                        <p className="text ar-dark-color fs-11 d-flex align-items-center gap-1"><i className="icon-price-sheild fs-12" />{mainPateintModal.InsuranceName}</p>
                                        <div className="d-flex align-items-center justify-content-between w-100">
                                            <p className="text fs-11 font-m">{mainPateintModal.FollowUpVisit ? mainPateintModal.FollowUpVisit : 'Follow-up Visit'}</p>
                                            <p className='copay font-m text fs-11 za-pat-copay px-1 py-0'>Copay Due : <span className='font-sb'>{!isNull(mainPateintModal.Copay) ? '$' + mainPateintModal.Copay : 'N/A'}</span></p>
                                        </div>
                                    </div>
                                </div>
                                <div className="d-flex justify-content-between my-1">
                                    {/* <p className="heading xsm_heading ar-dark-color">Provider: {mainPateintModal.Providers}</p> */}
                                </div>
                            </>
                            :
                            <>
                                <div className='d-flex justify-content-between ar-copay-img '>
                                    <div className="d-flex gap-4 py-2">
                                        <div className="img-container s-50 circle border-2  ar-bgc-img">
                                        </div>
                                        <div>
                                            <p className="ar-bgc-content m-0" style={{ width: '50%' }}></p>
                                            <p className="ar-bgc-content w-30 m-0 mt-2" ></p>
                                            <p className="ar-bgc-content w-30 m-0 mt-2" style={{ width: '80%' }}></p>
                                        </div>
                                    </div>
                                </div>
                            </>
                        }
                        <div className="mb-1 d-flex align-items-end gap-12">
                            <div className={`input mb-0 ${(isDateGreater || validation.DateCollectedVal) ? 'error' : ''}`}>
                                <label>Collected Date <span className='req'>*</span></label>
                                <div className="">
                                    <DatePicker
                                        // label='Date Collected'
                                        value={DateCollected}
                                        maxDate={new Date()}
                                        handleCalendarChangefunc={date => handleCalendarChange(date)}
                                        inputError={!isNull(validation.DateCollectedVal) ? true : false}
                                    />
                                    <span>{isDateGreater ? isDateGreater : validation.DateCollectedVal ? validation.DateCollectedVal : null}</span>
                                </div>
                            </div>
                            <div className="">
                                <div className={`input mb-0 ${validation.CollectedAmountVal ? 'error' : ''}`}>
                                    <label htmlFor="CollectedAmount" className=''>Collected Amount <span className='req'>*</span></label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Collected Amount"
                                        name="CollectedAmount"
                                        id="CollectedAmount"
                                        value={CollectedAmount}
                                        onKeyPress={(event) => handleDecimalCheck(event)}
                                        onChange={(e) => handleChangeAmount(e)}
                                    />
                                    {validation.CollectedAmountVal}
                                </div>
                            </div>
                        </div>

                        <div className="row patient_payment_tabs mt-2">
                            <span className="text ar-light-color">Payment Method</span>
                            <Tab.Container activeKey={paymentMethod}>
                                <div className='ms-0'>
                                    <Nav variant="tabs" className="d-flex border-0 gx-0 mt-1">
                                        <Nav.Item className="ar-copay-link ar-pad" onClick={() => handleChangeLink('Cash')}>
                                            <Nav.Link eventKey="Cash" className="text">Cash</Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item className="ar-copay-link ar-pad" onClick={() => handleChangeLink('Check')}>
                                            <Nav.Link eventKey="Check" className="text">Check</Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item className="ar-copay-link ar-pad" onClick={() => handleChangeLink('Credit')}>
                                            <Nav.Link eventKey="Credit" className="text">Credit</Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item className="ar-copay-link ar-pad" onClick={() => handleChangeLink('Other')}>
                                            <Nav.Link eventKey="Other" className="text">Other</Nav.Link>
                                        </Nav.Item>
                                        {AdvancePayment > 0 ?
                                            <Nav.Item className="ar-copay-link ar-pad" onClick={() => handleChangeLink('Patient Credit')}>
                                                <Nav.Link eventKey="Patient Credit" className="text d-flex align-items-center gap-1 isolation-unset">Patient Credit
                                                    <span className='font-sb orange-drk'>(${AdvancePayment})</span>
                                                    <span className='za-denied-status position-relative d-flex pat-cradit'>
                                                        <i className='icon-alert'></i>
                                                        <p className="xsm_text text-light tool_tip text-start">Patient Credit is the available balance from advance payments </p>
                                                    </span>
                                                </Nav.Link>
                                            </Nav.Item>
                                            : null}
                                    </Nav>
                                </div>
                                <Tab.Content>
                                    <Tab.Pane eventKey='Cash'>
                                        <div className="cash-tab">
                                            {/* <div className=" row mt-2 gx-0 align-items-center">
                                                <div className="col-5 d-flex custom_check_box ">
                                                    <input
                                                        type="checkbox"
                                                        name="CopayDue"
                                                        className='form-check-input p-0'
                                                        id="CopayDueCash"
                                                        checked={mainCash.CopayDue}
                                                        onChange={(e) => handleChangePatientPayment(e, 'cash')}
                                                    />
                                                    <span className="text ar-light-color ms-2" for='CopayDueCash'>Copay Due</span>
                                                </div>
                                                <div className="col-3">
                                                    <p className="text ar-light-color mt-2 ">{!isNull(mainPateintModal.Copay) ? '$' + mainPateintModal.Copay : 'N/A'}</p>
                                                </div>
                                                <div className="col-4">
                                                    <input
                                                        type="text"
                                                        className="form-control fc-xs rounded form-control-amount mt-1"
                                                        placeholder="Collected Amount"
                                                        name="CollectedAmount"
                                                        id="CollectedAmount"
                                                        value={CollectedAmount}
                                                        onKeyPress={(event) => handleDecimalCheck(event)}
                                                        onChange={(e) => handleChangeAmount(e)}
                                                    />
                                                    {validation.CollectedAmountVal}
                                                </div>
                                            </div> */}

                                            {/* <div className=" row mt-2 ">
                                        <div className="col-5">
                                            <input type="checkbox" name="coPay" id="coPay" />
                                            <span className="text ar-light-color ms-2 ">Previous Balance</span>
                                        </div>
                                        <div className="col-7 d-flex gap-5">
                                            <p className="text mt-2 ar-light-color ">$100</p>
                                            <input type="text" className="form-control fc-xs rounded w-75 form-control-amount mt-1 " name="ClaimID" id="ClaimID" value="" />
                                        </div>
                                    </div> */}
                                        </div>
                                    </Tab.Pane>
                                    <Tab.Pane eventKey='Check' >
                                        <div className="check-tab">

                                            {/* <div className="row mt-2 align-items-center">
                                                <div className="col-5 custom_check_box d-flex ">
                                                    <input
                                                        type="checkbox"
                                                        name="CopayDue"
                                                        className='form-check-input'
                                                        id="CopayDueCheck"
                                                        checked={mainCheck.CopayDue}
                                                        onChange={(e) => handleChangePatientPayment(e, 'check')}
                                                    />
                                                    <span className="text ar-light-color ms-2 ">Copay Due</span>
                                                </div>
                                                <div className="col-7 d-flex gap-5">
                                                    <p className="text ar-light-color mt-2 ">{!isNull(mainPateintModal.Copay) ? '$' + mainPateintModal.Copay : 'N/A'}</p>
                                                    <input
                                                        type="text"
                                                        className="form-control fc-xs rounded w-75 form-control-amount mt-1"
                                                        placeholder="Collected Amount"
                                                        name="CollectedAmount"
                                                        id="CollectedAmount"
                                                        value={CollectedAmount}
                                                        onKeyPress={(event) => handleNumericCheck(event)}
                                                        onChange={(e) => handleChangeAmount(e)}
                                                    />
                                                </div>
                                            </div> */}

                                            {/* <div className=" row mt-2 ">
                                        <div className="col-5">
                                            <input type="checkbox" name="coPay" id="coPay" />
                                            <span className="text ar-light-color ms-2 ">Previous Balance</span>
                                        </div>
                                        <div className="col-7 d-flex gap-5">
                                            <p className="text mt-2 ar-light-color ">$100</p>
                                            <input type="text" className="form-control fc-xs rounded w-75 form-control-amount mt-1 " name="ClaimID" id="ClaimID" value="" />
                                        </div>
                                    </div> */}
                                            <div className="row" >
                                                <div className="col-6">
                                                    <label htmlFor="chk" className="text ar-light-color">Check # <span className='req'>*</span></label> <br />
                                                    <input
                                                        type="text"
                                                        name="Check"
                                                        id="Check"
                                                        className={validation.CheckVal ? 'form-control fc-xs rounded  error' : 'form-control fc-xs rounded'}
                                                        value={mainCheck.Check}
                                                        onChange={(e) => handleChangePatientPayment(e, 'check')}
                                                    />
                                                    {validation.CheckVal}
                                                </div>
                                                <div className="col-6">
                                                    <label htmlFor="chk1" className="text ar-light-color">Check Amount</label> <br />
                                                    <input
                                                        type="text"
                                                        name="CheckAmount"
                                                        id="CheckAmount"
                                                        className="form-control fc-xs rounded"
                                                        value={mainCheck.CheckAmount}
                                                        onKeyPress={(event) => handleNumericCheck(event)}
                                                        onChange={(e) => handleChangePatientPayment(e, 'check')}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </Tab.Pane>
                                    <Tab.Pane eventKey='Credit' >
                                        <div className="credit-tab">

                                            {/* <div className=" row mt-2 align-items-center">
                                                <div className="col-5 custom_check_box d-flex">
                                                    <input
                                                        type="checkbox"
                                                        className='form-check-input'
                                                        name="CopayDue"
                                                        id="CopayDueCredit"
                                                        checked={mainCredit.CopayDue}
                                                        onChange={(e) => handleChangePatientPayment(e, 'credit')}
                                                    />
                                                    <span className="text ar-light-color ms-2 ">Copay Due</span>
                                                </div>
                                                <div className="col-7 d-flex gap-5">
                                                    <p className="text ar-light-color mt-2 ">{!isNull(mainPateintModal.Copay) ? '$' + mainPateintModal.Copay : 'N/A'}</p>
                                                    <input
                                                        type="text"
                                                        className="form-control fc-xs rounded w-75 form-control-amount mt-1"
                                                        placeholder="Collected Amount"
                                                        name="CollectedAmount"
                                                        id="CollectedAmount"
                                                        value={CollectedAmount}
                                                        onKeyPress={(event) => handleNumericCheck(event)}
                                                        onChange={(e) => handleChangeAmount(e)}
                                                    />
                                                </div>
                                            </div> */}

                                            {/* <div className=" row mt-2 ">
                                        <div className="col-5">
                                            <input type="checkbox" name="coPay" id="coPay" />
                                            <span className="text ar-light-color ms-2 ">Previous Balance</span>
                                        </div>
                                        <div className="col-7 d-flex gap-5">
                                            <p className="text mt-2 ar-light-color ">$100</p>
                                            <input type="text" className="form-control fc-xs rounded w-75 form-control-amount mt-1 " name="ClaimID" id="ClaimID" value="" />
                                        </div>
                                    </div> */}
                                            {/* <div className=" row align-items-center " >
                                                <div class="col-5">
                                                    <label for="creditCard" className="text ar-light-color ps-1" >Credit Card <span className='req'>*</span></label>
                                                    <input
                                                        type="text"
                                                        className={validation.CreditVal ? 'form-control fc-xs rounded error' : 'form-control fc-xs rounded'}
                                                        name="CreditCard"
                                                        id="CreditCard"
                                                        value={mainCredit.CreditCard}
                                                        onChange={(e) => handleChangePatientPayment(e, 'credit')}
                                                    />
                                                    {validation.CreditVal}
                                                </div>
                                                <div className="col-7">
                                                    <label htmlFor="Last4Digits" className="text ar-light-color">Last 4-Digits of Card</label>
                                                    <div className="d-flex align-items-center">
                                                        <label className="col-6 text ar-light-color fs-10"> XXXX-XXXX-XXXX-</label>
                                                        <input
                                                            type="text"
                                                            name="Last4Digits"
                                                            id="Last4Digits"
                                                            className="col-5 form-control fc-xs rounded w-50"
                                                            value={mainCredit.Last4Digits}
                                                            onKeyPress={(event) => handleNumericCheck(event)}
                                                            onChange={(e) => handleChangePatientPayment(e, 'credit')}
                                                        />
                                                    </div>
                                                </div>
                                            </div> */}
                                        </div>
                                    </Tab.Pane>

                                    <Tab.Pane eventKey='Other' >
                                        <div className="other-tab">

                                            {/* <div className="row mt-2 align-items-center">
                                                <div className="col-5 custom_check_box d-flex">
                                                    <input
                                                        type="checkbox"
                                                        name="CopayDue"
                                                        className='form-check-input'
                                                        id="CopayDueOther"
                                                        checked={mainOther.CopayDue}
                                                        onChange={(e) => handleChangePatientPayment(e, 'other')}
                                                    />
                                                    <span className="text ar-light-color ms-2 ">Copay Due</span>
                                                </div>
                                                <div className="col-7 d-flex gap-5">
                                                    <p className="text ar-light-color mt-2 ">{!isNull(mainPateintModal.Copay) ? '$' + mainPateintModal.Copay : 'N/A'}</p>
                                                    <input
                                                        type="text"
                                                        className="form-control fc-xs rounded w-75 form-control-amount mt-1"
                                                        placeholder="Collected Amount"
                                                        name="CollectedAmount"
                                                        id="CollectedAmount"
                                                        value={CollectedAmount}
                                                        onKeyPress={(event) => handleNumericCheck(event)}
                                                        onChange={(e) => handleChangeAmount(e)}
                                                    />
                                                </div>
                                            </div> */}

                                            {/* <div className=" row mt-2 ">
                                        <div className="col-5">
                                            <input type="checkbox" name="coPay" id="coPay" />
                                            <span className="text ar-light-color ms-2 ">Previous Balance</span>
                                        </div>
                                        <div className="col-7 d-flex gap-5">
                                            <p className="text mt-2 ar-light-color ">$100</p>
                                            <input type="text" className="form-control fc-xs rounded w-75 form-control-amount mt-1 " name="ClaimID" id="ClaimID" value="" />
                                        </div>
                                    </div> */}
                                            <div>
                                                <div>
                                                    <label htmlFor="chk" className="text ar-light-color">Other Payment Method</label> <br />
                                                    <input
                                                        type="text"
                                                        name="OtherPaymentMethod"
                                                        id="OtherPaymentMethod"
                                                        className="form-control fc-xs rounded w-50 text"
                                                        value={mainOther.OtherPaymentMethod}
                                                        onChange={(e) => handleChangePatientPayment(e, 'other')}
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                    </Tab.Pane>

                                    <Tab.Pane eventKey='Patient Credit' >
                                        <div className="cash-tab">

                                            {/* <div className=" row mt-2 align-items-center">
                                                <div className="col-5 custom_check_box d-flex">
                                                    <input
                                                        type="checkbox"
                                                        className='form-check-input'
                                                        name="CopayDue"
                                                        id="CopayDuePtCredit"
                                                        checked={mainPtCredit.CopayDue}
                                                        onChange={(e) => handleChangePatientPayment(e, 'ptcredit')}
                                                    />
                                                    <span className="text ar-light-color ms-2 ">Copay Due</span>
                                                </div>
                                                <div className="col-7 d-flex gap-5">
                                                    <p className="text ar-light-color mt-2 ">{!isNull(mainPateintModal.Copay) ? '$' + mainPateintModal.Copay : 'N/A'}</p>
                                                    <input
                                                        type="text"
                                                        className="form-control fc-xs rounded w-75 form-control-amount mt-1"
                                                        placeholder="Collected Amount"
                                                        name="CollectedAmount"
                                                        id="CollectedAmount"
                                                        value={CollectedAmount}
                                                        onKeyPress={(event) => handleNumericCheck(event)}
                                                        onChange={(e) => handleChangeAmount(e)}
                                                    />
                                                </div>
                                            </div> */}

                                            {/* <div className=" row mt-2 ">
                                        <div className="col-5">
                                            <input type="checkbox" name="coPay" id="coPay" />
                                            <span className="text ar-light-color ms-2 ">Previous Balance</span>
                                        </div>
                                        <div className="col-7 d-flex gap-5">
                                            <p className="text mt-2 ar-light-color ">$100</p>
                                            <input type="text" className="form-control fc-xs rounded w-75 form-control-amount mt-1 " name="ClaimID" id="ClaimID" value="" />
                                        </div>
                                    </div> */}
                                        </div>
                                    </Tab.Pane>

                                </Tab.Content>
                            </Tab.Container>
                            <div>
                                <label htmlFor="cmnt" className="text mb-1 ar-light-color">Comments</label><br />
                                <textarea name="cmnt" id="cmnt" rows="3" className="ar-texteara text w-100" value={Comments} onChange={(e) => setComments(e.target.value)}></textarea>
                            </div>


                        </div>
                    </div>
                </Modal.Body>
                <ModalFooter isSaved={OnCloseCopay} handleSave={handleSaveCopay} key={'CollectCopay'} Name={'CollectCopay'} UpdatedDate={''} UpdatedBy={''} ID={''} IsEditAllowed={true} />
            </Modal>
            <Modal show={isCopayAlreadyPaid} onHide={isCopayAlreadyPaid} backdrop="static" keyboard={false} centered dialogClassName="app-modal paid_copay hk-modal-v1">
                <div className='ar-header d-flex justify-content-between'>
                    <p className='text'>Attention Please</p>
                    <i className='icon-Icon-metro-cross cursor-pointer' onClick={handleCopayPaid}></i>
                </div>
                <div className='ar-content d-flex justify-content-center'>
                    <p className='text d-flex align-items-center'> <i className='icon-Vector3 fs-18'></i> Copay is already Paid</p>
                </div>
                <div className='br-top-1 ar-border-color'>
                    <div className='ar-footer d-flex justify-content-center align-items-center' onClick={handleCopayPaid}>
                        <p className='text text-white'>OK</p>
                    </div>
                </div>
            </Modal>
        </>
    )
}

export default CollectCopay